import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    meta: {layout: 'empty'},
    component: () => import('../views/Login.vue')
  },
  {
    path: '/mainContent',
    name: 'MainContent',
    meta: {layout: 'main','requiresAuth':true},
    component: () => import('../views/MainContent.vue')
  },
  {
    path: '/resetPasswordConfirm',
    name: 'ResetPasswordConfirm',
    meta: {layout: 'empty'},
    component: () => import('../views/ResetPasswordConfirm.vue')
  },
  {
    path: '/resetPassword',
    name: 'ResetPassword',
    meta: {layout: 'empty'},
    component: () => import('../views/ResetPassword.vue')
  },
  {
    path: '/authConfirm',
    name: 'AuthConfirm',
    meta: {layout: 'empty'},
    component: () => import('../views/AuthConfirm.vue')
  },
  {
    path: '/register',
    name: 'Register',
    meta: {layout: 'empty'},
    component: () => import('../views/Register.vue')
  },
  {
    path: '/user',
    name: 'User',
    meta: {layout: 'empty','requiresAuth':true},
    component: () => import('../views/User.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      next();
      return;
    }
    next("/");
  } else {
    next();
  }
});
export default router
